"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Visibility;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function Visibility(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M21.244 10.051a2.88 2.88 0 0 1 .002 3.89c-1.006 1.107-4.639 4.723-9.139 4.723h-.213c-4.501 0-8.133-3.615-9.137-4.723a2.88 2.88 0 0 1 0-3.89c.041-.047.083-.093.125-.138C5.23 7.388 8.456 5.358 12 5.33c.167 0 .324 0 .487.01 3.342.157 6.566 2.298 8.757 4.711zm-1.232 2.768a1.23 1.23 0 0 0 .003-1.649 15.076 15.076 0 0 0-2.059-1.88 12.708 12.708 0 0 0-2.833-1.648A7.84 7.84 0 0 0 12 6.997c-3.056-.071-6.04 2-8.012 4.176a1.23 1.23 0 0 0 0 1.648c.09.1.181.198.274.294C6.3 15.238 8.975 16.926 12 16.997a6.931 6.931 0 0 0 .81-.038c2.769-.26 5.394-2.15 7.202-4.14zM12 8.663a3.333 3.333 0 1 1-3.333 3.334 2.987 2.987 0 0 1 .083-.678.208.208 0 0 1 .334-.115 1.662 1.662 0 0 0 2.437-2.203.207.207 0 0 1 .153-.32A3.25 3.25 0 0 1 12 8.662z"
  }));
}